<template>
  <div class="relative w-full h-full" >
    <div v-show="isImageLoading" class="  z-[2] absolute inset-0 h-full w-full animate-pulse bg-[#97979729]"></div>
    <img
      draggable="false"
      :class="imgClass"
      :src="imageURL || defaultImg"
      @error="(e) => handleImgError(e)"
      @load="stopImageLoading"
      :loading="loadingType"
      :alt="imageName"
    />
  </div>
</template>

<script>
import defaultImg from "@/assets/images/placeholder(doNotRemove).jpg";
export default {
  name:'CustomImage',
  data() {
    return {
      isImageLoading: true,
      defaultImg
    };
  },
  props: {
    imageURL: {
      type: String,
      required: true,
      default: "#"
    },
    imageName: {
      type: String,
      required: false,
      default: ""
    },
    imgClass:{
      type: String,
      required: true,
      default: "w-full h-full object-cover"//to make img take size of parent
    },
    loadingType: {
      type: String,
      required: false,
      default: "lazy"
    }
  },
  methods: {
    stopImageLoading() {
      this.isImageLoading = false;
    },
    // handleImgError() {
    //   // to replace img when it has an error
    //   this.stopImageLoading();
    //   e.target.src = this.defaultImg;
    //   e.onerror = null;
    //   return true;
    // },
    handleImgError(e) {
      this.stopImageLoading();
      e.target.src = this.defaultImg;
      e.onerror = null;
      return true;
    },
    // handleImgLoaded(e,imgSrc) {
    //   this.isImgLoaded[imgSrc]=true
    //   return true;
    // },
  }
};
</script>

<style>
</style>